/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Has_MilestoneInputs */

const en_filter_has_milestone = /** @type {(inputs: Filter_Has_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a milestone`)
};

const de_filter_has_milestone = /** @type {(inputs: Filter_Has_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilenstein`)
};

/**
* | output |
* | --- |
* | "a milestone" |
*
* @param {Filter_Has_MilestoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_has_milestone = /** @type {((inputs?: Filter_Has_MilestoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Has_MilestoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_has_milestone(inputs)
	return en_filter_has_milestone(inputs)
});